import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ProductCardFile} from 'api/filtersData';
import {fetchProductCardAuditErrors} from 'api/productCardAudit';
import {EmptyDetail} from 'components/common/AuditLog/styled';
import {Modal} from 'components/ui-kit/Modal';
import {Spinner} from 'components/ui-kit/Spinner';
import {RestError, showRestError} from 'core/errors';

import {ChangesTable} from './styled';

export const ProductCardAuditErrorsModal = ({
    eventId,
    onClose,
}: {
    eventId: string;
    onClose: () => void;
}) => {
    const {t} = useTranslation();
    const [data, setData] = useState<ProductCardFile | null>(null);
    const [pending, setPending] = useState(true);
    useEffect(() => {
        let active = true;
        setPending(true);
        setData(null);
        fetchProductCardAuditErrors(eventId)
            .then((result) => {
                if (active) setData(result);
            })
            .catch((error) => {
                if (active) showRestError(error as RestError);
            })
            .finally(() => {
                if (active) setPending(false);
            });
        return () => {
            active = false;
        };
    }, [eventId]);
    return (
        <Modal show onClose={onClose} title={t('pages.productCardAudit.listOfErrors')}>
            {pending ? (
                <EmptyDetail>
                    <Spinner />
                </EmptyDetail>
            ) : !data ? (
                <EmptyDetail>{t('errors.occurred')}</EmptyDetail>
            ) : (
                <>
                    {data.error && <p>{data.error}</p>}
                    {data.errors?.length ? (
                        <ChangesTable>
                            <thead>
                                <tr>
                                    {['row', 'column', 'field', 'message'].map((key) => (
                                        <th key={key}>
                                            {t(`pages.productCardAudit.errorColumns.${key}`)}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.errors.map((error, index) => (
                                    <tr key={index}>
                                        <td>{error.row ?? '—'}</td>
                                        <td>{error.column || '—'}</td>
                                        <td>{error.fieldName || '—'}</td>
                                        <td>{error.message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </ChangesTable>
                    ) : (
                        !data.error && (
                            <EmptyDetail>{t('pages.productCardAudit.noErrors')}</EmptyDetail>
                        )
                    )}
                </>
            )}
        </Modal>
    );
};
